import styled from 'styled-components'

import { NavLink } from 'react-router-dom'

import { ShoppingCartOutlined } from '@ant-design/icons'

import sizes from 'src/styles/theme/sizes'

export const MenuIconStyledHome = styled.div`
  display: block;
  border: 1px solid white;
  border-radius: 43px;
  padding: 12px;

  svg {
    color: white;
  }

  @media screen and (min-width: ${sizes.lg}) {
    display: none;
  }
`
export const MenuIconStyled = styled(MenuIconStyledHome)`
  display: block;
  border: 1px solid #030852;
  border-radius: 43px;
  padding: 12px;

  svg {
    color: #030852;
  }
  @media screen and (min-width: ${sizes.lg}) {
    display: none;
  }
`

export const NavIconsWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  @media screen and (min-width: ${sizes.md}) {
    gap: 2rem;
  }
  @media screen and (max-width: 630px) {
    display: none;
  }
`

export const NavigationMobile = styled.ul`
  font-size: 0.875rem;
`

export const DrawerHeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  img.logo {
    height: 2rem;
  }
`
export const CartContainerHome = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding-block: 8px;
  padding-inline: 12px;
  border: 1px solid white;
  border-radius: 32px;
  color: white;
  text-decoration: none;
  width: fit-content;

  :hover {
    border: 1px solid #fdb123;
    svg,
    span {
      color: #fdb123;
      fill: #fdb123;
    }
  }
`
export const CartContainer = styled(CartContainerHome)`
  border: 1px solid #030852;
  color: #030852;
`
export const CartNumberHome = styled.span`
  font-size: 16px;
  color: white;
`
export const CartNumber = styled.span`
  font-size: 16px;
  color: #030852;
`

export const ShoppingCartIcon = styled(ShoppingCartOutlined)<{
  $isHome: boolean
  $isScrolled: boolean
}>`
  font-size: 24px;
  color: ${({ $isHome, $isScrolled }) => ($isHome && !$isScrolled ? '#ffffff' : '#030852')};
  transition: color 0.3s ease;
  :hover {
    color: #fdb123;
  }
`
